const START = "2026-11-01";
const LAST = "2027-02-10";
const DAY = 86400000;

export const melbDate = (now) => new Intl.DateTimeFormat("en-CA", { timeZone: "Australia/Melbourne" }).format(now);
const diff = (a, b) => Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / DAY);

// Melbourne calendar days; today counts as a day still available.
export function countdown(now = new Date()) {
  const today = melbDate(now);
  if (today < START) {
    const n = diff(today, START);
    return { state: "before", label: n === 1 ? "Starts tomorrow" : `Starts in ${n} days` };
  }
  if (today > LAST) return { state: "ended", label: "STP Run has ended" };
  const n = diff(today, LAST) + 1;
  return { state: "live", days: n, label: `${n} ${n === 1 ? "day" : "days"} to go` };
}
